import { cx } from '@vizit/theme';
import * as React from 'react';

interface FormErrorProps extends React.HTMLAttributes<HTMLDivElement> {
  /**
   * The error message to display.
   */
  message?: string | null;
}

const FormError = React.forwardRef<HTMLDivElement, FormErrorProps>((props, ref) => {
  const { message, className, ...others } = props;

  if (!message) return null;

  return (
    <div ref={ref} className={cx('text-sm text-error-primary', className)} {...others}>
      {message}
    </div>
  );
});

export { FormError };
export type { FormErrorProps };
